import React from "react"
import Checkboxes from "./Checkboxes"
import "./Section.08.End.css"

export default function EndSection(params) {

    const {rescue, values} = params
    
    return <li className="accordion">
        <input type="checkbox" className="accordion" name="accordion" id="acc-end"/>
        <label className="accordion" htmlFor="acc-end">Završetak akcije</label>
        <section className="accordion">
        
            <div className="field">		
    		    <label htmlFor="belongings" className="above">Kome je predata lična oprema povređenog</label>
    		    <input type="text" value={rescue.rescue.belongings || ''} list="belongings_list" id="belongings" placeholder="Izaberi iz liste ili upiši sam..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
    		    <datalist id="belongings_list">
        		    {values?.belongings?.map(value => <option key={value}>{value}</option>)}
    		    </datalist>
            </div>
            
            <div className="field">
      		    <label htmlFor="receiver" className="above">
          		    <div>Povređenog primio</div>
          		    <div className="hint">Kome je predat povređeni, u nominativu</div>
      		    </label>
      		    <input type="text" value={rescue.rescue.receiver || ''} list="receiver_list" id="receiver" placeholder="Izaberi iz liste ili upiši sam...." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
      		    <datalist id="receiver_list">
          		    {values?.receivers?.map(value => <option key={value}>{value}</option>)}
      		    </datalist>
            </div>
            
            <div className="field full">
      		    <label htmlFor="material_desc" className="above">Medicinski materijal predat sa povređenim</label>
      		    <Checkboxes values={values?.materials} selected={rescue.rescue.material} onChange={list => rescue.setField("material", list)}/>
      			<input type="text" value={rescue.rescue.material_desc || ''} id="material_desc" className="underline" placeholder="Ostalo..." onChange={rescue.onChange} readOnly={rescue.isReadOnly}/>
            </div>
          
        </section>
     </li>
    
}